import { Calculator } from '@dynameat/views/reporting/models';
import { EvolutiveQuery } from '../queries';
import { EVOLUTIVE } from '../constants';

export class EvolutiveCalculator extends Calculator {
  kpiType = EVOLUTIVE

  constructor(productGuid, startDate, endDate, serviceGuid) {
    super();
    this.productGuid = productGuid;
    this.startDate = startDate;
    this.endDate = endDate;
    this.serviceGuid = serviceGuid;
  }

  async calculateKPI() {
    const evolutiveResponse = await this.executeUncubeQuery(EvolutiveQuery, this.productGuid,
      this.startDate, this.endDate, this.serviceGuid);
    const evolutiveResults = Object.fromEntries(evolutiveResponse.data.result.map(this.processEvolutive));
    const props = this.getData(evolutiveResults);
    return this.getModelToInstance(props);
  }

  executeUncubeQuery(queryClass, ...args) {
    // eslint-disable-next-line new-cap
    const uncubeQuery = new queryClass(...args);
    return uncubeQuery.execute();
  }

  processEvolutive(row) {
    // row = [date, {kpi: value}]
    return [
      row[0],
      {
        price: Math.round(row[1] * 100) / 100,
        margin: Math.round(((row[2] - row[3]) / row[4]) * 100) / 100,
        sales: Math.round(row[4] * 100) / 100
      }
    ];
  }

  getData(evolutiveResults) {
    const serviceKey = (this.serviceGuid) ? `-${this.serviceGuid}` : '';
    const startDateToString = this.startDate.toDateString();
    const endDateToString = this.endDate.toDateString();
    const currentKpi = this.getValueOfKpi(evolutiveResults);
    return {
      key: `${this.productGuid}-${startDateToString}-${endDateToString}${serviceKey}`,
      kpi: currentKpi,
      increment: null,
      type: this.kpiType,
    };
  }

  getDaysArray(start, end) {
    let arr;
    let dt;
    for (arr = [], dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
      arr.push(new Date(dt));
    }
    return arr;
  }

  getValueOfKpi(evolutiveResults) {
    const dates = this.getDaysArray(new Date(this.startDate), new Date(this.endDate));
    const dateStrings = dates.map((date) => date.toISOString().split('T')[0]);
    const price = Object.fromEntries(dateStrings.map((date) => [date, evolutiveResults[date]?.price || 0]));
    const margin = Object.fromEntries(dateStrings.map((date) => [date, evolutiveResults[date]?.margin || 0]));
    const sales = Object.fromEntries(dateStrings.map((date) => [date, evolutiveResults[date]?.sales || 0]));
    return {
      price,
      margin,
      sales
    };
  }
}
